module.exports = __webpack_public_path__ + "47d0247a9519d35f3b2a75be2037db51.glb";